/**
 * Marketing band under the header. Presentational only — the signup form is
 * not wired to a backend yet, so it deliberately does nothing on submit.
 */
export function TldrSubscribeBand() {
  return (
    <section className="tldr-marketing">
      <h1>Keep up with tech in 5 minutes</h1>
      <p className="tldr-marketing-sub">
        The free daily email with the stories Silicon Valley actually reads.
      </p>
      <form className="tldr-marketing-form" onSubmit={(e) => e.preventDefault()}>
        <input type="email" placeholder="Email address" aria-label="Email address" />
        <button type="submit">Subscribe</button>
      </form>
      <p className="tldr-marketing-note">
        Join 8,000,000+ readers from Anthropic, OpenAI and more for{' '}
        <a href="/newsletters">one daily email</a>
      </p>
    </section>
  );
}
